<template lang="pug">
  img(:src="image", @error="error = true", @load="loadHandler")
</template>

<script>
export default {
  props: {
    src: String,
    placeholder: String,
    refresh: Number,
    contain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    image () {
      if (this.error && this.placeholder) return this.placeholder
      if (this.refresh) return `${this.src}?cache=${this.cached}`
      else return this.src
    }
  },
  methods: {
    loadHandler ({target}) {
      if (!this.contain) return;
      let {width, height} = target
      let parent = target.parentElement
      // if (/a/i.test(parent.tagName)) {
      //   parent = parent.parentElement
      // }
      let {offsetWidth, offsetHeight} = parent
      let parentRatio = offsetWidth / offsetHeight
      let imageRatio = width / height

      if (imageRatio > parentRatio) target.className = 'w-100'
      else target.className = 'h-100'

      if (this.refresh) {
        this.timer = setInterval(() => {
          this.cached = Date.now()
        }, this.refresh)
      }
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  data () {
    return {
      timer: null,
      cached: Date.now(),
      error: false
    }
  }
}
</script>